// Centralised analytics consent management.
// Both Google Analytics and PostHog are only activated after the user
// explicitly accepts cookies. Declining keeps the app fully functional.

const GA_MEASUREMENT_ID = 'G-45L5C6V7JR';
const CONSENT_KEY = 'sideoutiq_cookie_consent';

export type ConsentState = 'accepted' | 'declined' | null;

export function getConsentState(): ConsentState {
  try {
    const v = localStorage.getItem(CONSENT_KEY);
    if (v === 'accepted' || v === 'declined') return v;
    return null;
  } catch {
    return null;
  }
}

export function saveConsentState(state: 'accepted' | 'declined'): void {
  try {
    localStorage.setItem(CONSENT_KEY, state);
  } catch {
    // ignore — localStorage unavailable (private browsing on some browsers)
  }
}

let gaLoaded = false;

/** Dynamically inject the Google Analytics script. Safe to call multiple times. */
export function loadGoogleAnalytics(): void {
  if (gaLoaded || document.getElementById('ga-script')) {
    gaLoaded = true;
    return;
  }
  gaLoaded = true;

  // Declare gtag globals.
  // NOTE: gtag.js requires the raw `arguments` object here, not an array.
  // Pushing an array (e.g. via rest params) means gtag.js silently ignores the
  // js/config commands and no page_view is ever sent — GA reports zero traffic.
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    w.dataLayer.push(arguments);
  }
  w.gtag = gtag;
  w.gtag('js', new Date());
  w.gtag('config', GA_MEASUREMENT_ID);

  const script = document.createElement('script');
  script.id = 'ga-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}
